import { DatePicker, Dropdown, Menu, Modal, Space } from "antd";
import { UiButton, UiRangePicker, UiSearch, UiTab, UiTable } from "../../../components";
import { actionDots, cancelConsultationIcon, completeConsultationIcon, consultationAmountIcon, downloadReport, gstIcon, lawyerFees, refundIcon, revenueIcon, totalConsultationIcon, upcomingConsultationIcon } from "../../../assets/images";
import closeIcon from "../../../assets/images/close.svg";
import { lang_en_US as translation } from "../../../config";
import dayjs from "dayjs";
import React, { useEffect, useRef, useState } from "react";
import { CONSULTATION_MONITORING_HEADER_COLUMNS, pendingConsultationDropdown, tabData } from "./config";
import * as api from "../../../actions";
import { COMPLAINTS, CONSULTATION, CUSTOMERMANAGEMENT, LAWYERMANAGEMENT, PAYMENTMANAGEMENT, SENDMESSAGEMAILID, SENDMESSAGEWHATSAPP, TRANSACTIONMANAGEMENT } from "../../../apiServices/endpoints";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useDispatch } from "react-redux";
import { loaderReducer } from "../../../reducer/loader.reducer";
import ConsultationView from "../../../components/consultation/consultationView";
import { searchInitiateDelayTime, tablePageSizeOptions, formatAmount, parseErrorMessage, isConsultationRefundExpired } from "../../../utils/appUtils";
import { useReactToPrint } from "react-to-print";
import ConsultationMonitoringReport from "./report";
import ComplaintView from "../../../components/consultation/complaintView";
import { showErrorNotification, showSuccessNotification } from "../../../components/uiNotification";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { messageTabData } from "../../../components/complaints/config";
import "./style.scss";

const PrintConsultationReports = React.forwardRef((props, ref) => {
    return <div ref={ref}>
        <ConsultationMonitoringReport data={props?.data} fromDate={props?.fromDate} toDate={props?.toDate} activeTab={props?.activeTab} consultationMonitoring={props?.consultationMonitoring} month={props?.month} year={props?.year} minFilter={props?.minFilter} searchFilter={props?.searchFilter} />
    </div>
});

const ConsultationMonitoring = () => {
    const keywords = translation?.consultation;
    const dispatch = useDispatch();
    const queryClient = useQueryClient();
    const debounceTimeOut = useRef(null);
    const reportRef = useRef(null);
    const userId = sessionStorage.getItem("userId");

    const handlePrint = useReactToPrint({
        content: () => reportRef.current,
        onAfterPrint: () => setConsultationFilter(prev => ({ ...prev, size: 10, isReportOpen: false })),
        pageStyle: `@page {
                            size: A4 landscape !important;
                            margin: 8mm !important;
                        }
                        @media print {
                            @page {
                                size: A4 landscape !important;
                                margin: 8mm !important;
                            }
                        }
                        body {
                            -webkit-print-color-adjust: exact;
                            print-color-adjust: exact;
                        }
                        .consultationMonitoring-report::before{
                                content: "";
                                position: fixed;
                                top: 0;
                                left: 0;
                                right: 0;
                                bottom: 0;
                                border: 2px solid #005D60;
                                z-index: 9999;
                                pointer-events: none;
                            }
                        .consultationMonitoring-report .consultation-card {
                                width: 10% !important;
                                min-width: 0 !important;
                                flex: 1 1 0 !important;
                        }
                        .consultationMonitoring-report .consultation-card img {
                                width: 16px !important;
                                height: 16px !important;
                        }
                        .consultationMonitoring-report .consultation-card-title {
                                font-size: 10.5px !important;
                                line-height: 1.2 !important;
                        }
                        .consultationMonitoring-report .consultation-card h3 {
                                font-size: 12px !important;
                                margin-top: 4px !important;
                                margin-bottom: 2px !important;
                        }
                        .consultationMonitoring-report .todays-count {
                                font-size: 9.5px !important;
                                line-height: 1.2 !important;
                        }`
    });

    const [consultationFilters, setConsultationFilter] = useState({
        page: 0, size: 10, activeTab: "COMPLETED", activeTabKey: "1", searchFilter: "", searchTermValue: "", month: null, monthString: "", fromDate: "", toDate: "", year: "", consultationTime: 0, isReportOpen: false
    });
    const [consultationData, setConsultationData] = useState({});
    const [consultationBooleans, setConsultationBooleans] = useState({
        isconsultationDrawerOpen: false,
        isComplaintDrawerOpen: false,
        isConsultationReportOpen: false,
        isSendMessage: false,
        isSendWarningMessage: false,
        isComplaintReportOpen: false,
        isDownloadButtonEnable: false,
    });
    const [consultationIdData, setConsultationIdData] = useState({ lawyerProfile: "", customerProfile: "", consultationInfo: {} });
    const [selectedConsultationForComplaint, setSelectedConsultationForComplaint] = useState({});
    const [messageData, setMessageData] = useState({
        againstById: "",
        raisedById: "",
        body: "",
        subject: "",
        complaintType: "",
        warning: false,
        activeTab: "raised",
        complaintId: "",
        warnedBy: "",
        activeTabKey: "1",
        isWhatsapp: false,
        isMail: true,
        isButtonEnable: false
    });
    const [complaintIdData, setComplaintIDData] = useState({ rasiedByProfile: "", againstByProfile: "", data: {} });
    const [refundModal, setRefundModal] = useState({ open: false, loading: false });

    const getAllConsultation = (consultationFilters) => api.get(`${CONSULTATION}/consultation_monitoring?size=${consultationFilters?.size}&page=${consultationFilters?.page}${consultationFilters?.activeTab === "LOW_RATING" ? `&isLowConsultation=${true}` : consultationFilters?.activeTab ? `&consultationStatus=${consultationFilters?.activeTab}` : ""}${consultationFilters?.consultationTime ? `&consultationTime=${consultationFilters?.consultationTime}` : ""}${consultationFilters?.monthString ? `&month=${consultationFilters?.monthString}` : ""}${consultationFilters?.fromDate && consultationFilters?.toDate ? `&startDate=${consultationFilters?.fromDate}&endDate=${consultationFilters?.toDate}` : ""}${consultationFilters?.searchTermValue ? `&commonSearch=${consultationFilters?.searchTermValue}` : ""}${consultationFilters?.year ? `&year=${dayjs(consultationFilters?.year).format("YYYY")}` : ""}`);
    const getConsultationById = (id) => api.get(`${CONSULTATION}/${id}`);
    const getComplaintById = (id) => api.get(`${COMPLAINTS}/${id}`);
    const sendWhatsAppMessage = (payload) => api.post(`${SENDMESSAGEWHATSAPP}`, payload);
    const sendMailMessage = (payload) => api.post(`${SENDMESSAGEMAILID}`, payload);

    const { refetch: fetchConsultation, isFetching: isFetchingAllConsultation } = useQuery(["FETCH_ALL_CONSULTATION", consultationFilters?.page, consultationFilters?.size, consultationFilters?.activeTab, consultationFilters?.consultationTime, consultationFilters?.monthString, consultationFilters?.fromDate, consultationFilters?.toDate, consultationFilters?.searchTermValue, consultationFilters?.year], () => getAllConsultation(consultationFilters), {
        onSuccess: (consultationResponse) => {
            if (consultationResponse?.statusCode === 200) {
                setConsultationData(consultationResponse?.result?.consultationMonitoringResponse);
            }
        },
        enabled: Boolean(consultationFilters?.page || consultationFilters?.size || consultationFilters?.activeTab || consultationFilters?.consultationTime || consultationFilters?.monthString || consultationFilters?.fromDate || consultationFilters?.toDate || consultationFilters?.searchTermValue || consultationFilters?.year),
        refetchOnWindowFocus: false
    });

    const { isFetching: isFetchingConsultationById } = useQuery(["FETCH_CONSULTATION_BY_ID", ""], getConsultationById, {
        onSuccess: (consultationIdResponse) => {
            if (consultationIdResponse?.statusCode === 200) {
                setConsultationBooleans(prev => ({ ...prev, isconsultationDrawerOpen: true }));
                setConsultationIdData(prev => ({
                    ...prev,
                    lawyerProfile: `${LAWYERMANAGEMENT}/file${consultationIdResponse?.result?.consultationResponse?.lawyerResponse?.profileUrl}`,
                    customerProfile: `${CUSTOMERMANAGEMENT}/file${consultationIdResponse?.result?.consultationResponse?.customerResponse?.profileUrl}`,
                    consultationInfo: consultationIdResponse?.result?.consultationResponse
                }));
            }
        },
        enabled: false,
        refetchOnWindowFocus: false
    });

    const { isFetching: isFetchingComplaintById } = useQuery(["FETCH_COMPLAINT_BY_ID", ""], getComplaintById, {
        onSuccess: (complaintResponse) => {
            if (complaintResponse?.statusCode === 200) {
                setConsultationBooleans(prev => ({ ...prev, isComplaintDrawerOpen: true }));
                const complaintResponseData = complaintResponse?.result?.complaintResponse || {};
                const isCustomerRaised = complaintResponseData?.complaintType === "COMPLAINT_RAISED_CUSTOMER";
                const selectedConsultationDetails = selectedConsultationForComplaint?.consultationDetails || {};
                const selectedConsultationPaymentDetails = selectedConsultationForComplaint?.consultationPaymentDetails || {};

                const mergedConsultationDetails = {
                    ...selectedConsultationDetails,
                    ...complaintResponseData?.consultationDetails,
                    recordDetail: complaintResponseData?.consultationDetails?.recordDetail || selectedConsultationDetails?.recordDetail
                };

                const mergedConsultationPaymentDetails = {
                    ...selectedConsultationPaymentDetails,
                    ...complaintResponseData?.consultationPaymentDetails,
                    recordDetail: complaintResponseData?.consultationPaymentDetails?.recordDetail || selectedConsultationPaymentDetails?.recordDetail
                };

                const mergedComplaintData = {
                    ...complaintResponseData,
                    consultationDetails: mergedConsultationDetails,
                    consultationPaymentDetails: mergedConsultationPaymentDetails
                };

                setComplaintIDData(prev => ({
                    ...prev,
                    rasiedByProfile: `${isCustomerRaised ? CUSTOMERMANAGEMENT : LAWYERMANAGEMENT}/file${complaintResponseData?.raisedByProfileUrl || ""}`,
                    againstByProfile: `${isCustomerRaised ? LAWYERMANAGEMENT : CUSTOMERMANAGEMENT}/file${complaintResponseData?.againstByProfileUrl || ""}`,
                    data: mergedComplaintData
                }));
            }
        },
        enabled: false,
        refetchOnWindowFocus: false
    });

    const { isFetching: isFetchingSendMessage } = useQuery(["SEND_MESSAGE_WHATSAPP", ""], sendWhatsAppMessage, {
        onSuccess: (sendResponse) => {
            if (sendResponse?.data?.statusCode === 200) {
                handleSendMessageClose();
                setConsultationBooleans(prev => ({ ...prev, isSendMessage: false, isSendWarningMessage: false }));
                setMessageData(prev => ({ ...prev, activeTab: "raised", activeTabKey: "1", isMail: true, isWhatsapp: false, body: "", subject: "" }));
                showSuccessNotification("Success", sendResponse?.data?.result?.result);
                fetchConsultation();
            }
        },
        enabled: false,
        refetchOnWindowFocus: false
    });

    const { isFetching: isFetchingSenfMailMessage } = useQuery(["SEND_MESSAGE_MAIL", ""], sendMailMessage, {
        onSuccess: (mailResponse) => {
            if (mailResponse?.data?.statusCode === 200) {
                setConsultationBooleans(prev => ({ ...prev, isSendMessage: false, isSendWarningMessage: false }));
                setMessageData(prev => ({ ...prev, activeTab: "raised", activeTabKey: "1", isMail: true, isWhatsapp: false, body: "", subject: "" }));
                showSuccessNotification("Success", mailResponse?.data?.result?.result);
                fetchConsultation();
            }
        },
        enabled: false,
        refetchOnWindowFocus: false
    });

    const handleTabChanges = (key) => {
        tabData?.forEach((tab) => {
            if (tab?.key === key) {
                const { content } = tab || {};
                setConsultationFilter(prev => ({ ...prev, activeTab: content, activeTabKey: key, month: null, monthString: "", fromDate: "", toDate: "", year: "", searchFilter: "", searchTermValue: "", consultationTime: 0, page: 0, size: 10 }));
            }
        });
    };


    const getConsultationDropdown = (details) => {
        const lawyerComplaint = details?.lawyerComplaintDto && Object.keys(details?.lawyerComplaintDto)?.length > 0;
        const customerComplaint = details?.customerComplaintDto && Object.keys(details?.customerComplaintDto)?.length > 0;
        if (lawyerComplaint && customerComplaint) {
            return [
                { key: "view", label: "View" },
                { key: "viewLawyerRasiedComplaints", label: "View Lawyer Rasied Complaint" },
                { key: "viewCustiomerRasiedComplaint", label: "View Customer Rasied Complaint" },
            ]
        }
        else if (lawyerComplaint || customerComplaint) {
            return [
                { key: "view", label: "View" },
                { key: "viewComplaint", label: "View Complaints" },
            ]
        }
        else {
            return [
                { key: "view", label: "View" },
            ]
        }
    };

    const handleAction = (menuType, list) => {
        if (menuType === "view") {
            queryClient.prefetchQuery(["FETCH_CONSULTATION_BY_ID", ""], () => getConsultationById(list?.consultationId));
        }
        else if (menuType === "viewComplaint") {
            setConsultationBooleans(prev => ({ ...prev, isDownloadButtonEnable: true }));
            setSelectedConsultationForComplaint(list || {});
            let complaintId = null;
            if (list?.lawyerComplaintDto && Object.keys(list?.lawyerComplaintDto)?.length > 0) {
                complaintId = list.lawyerComplaintDto?.complaintId;
            }
            if (list?.customerComplaintDto && Object.keys(list?.customerComplaintDto)?.length > 0) {
                complaintId = list?.customerComplaintDto?.complaintId;
            }
            queryClient.prefetchQuery(["FETCH_COMPLAINT_BY_ID", ""], () => getComplaintById(complaintId));
        }
        else if (menuType === "viewLawyerRasiedComplaints") {
            setConsultationBooleans(prev => ({ ...prev, isDownloadButtonEnable: true }));
            setSelectedConsultationForComplaint(list || {});
            queryClient.prefetchQuery(["FETCH_COMPLAINT_BY_ID", ""], () => getComplaintById(list?.lawyerComplaintDto?.complaintId));
        }
        else if (menuType === "viewCustiomerRasiedComplaint") {
            setConsultationBooleans(prev => ({ ...prev, isDownloadButtonEnable: true }));
            setSelectedConsultationForComplaint(list || {});
            queryClient.prefetchQuery(["FETCH_COMPLAINT_BY_ID", ""], () => getComplaintById(list?.customerComplaintDto?.complaintId));
        }
    };

    const menuList = (menuItems, list) => {
        return <Menu>
            {
                menuItems?.map((menuDetails) => {
                    return <Menu.Item key={menuDetails?.key} onClick={(event) => {
                        event?.domEvent?.stopPropagation();
                        handleAction(menuDetails?.key, list);
                    }}>
                        {menuDetails?.label}
                    </Menu.Item>
                })
            }
        </Menu>
    };

    const actionRender = (list, filteredList) => {
        return <div style={{ textAlign: "center" }} onClick={(event) => event?.stopPropagation()}>
            <Dropdown overlay={(menuList(consultationFilters?.activeTab === "COMPLETED" || consultationFilters?.activeTab === "CANCELLED" ? filteredList : pendingConsultationDropdown, list))} trigger={["click"]}>
                <Space onClick={(event) => {
                    event?.preventDefault();
                    event?.stopPropagation();
                }} style={{ justifyContent: "center", width: "100%", cursor: "pointer" }}>
                    <img src={actionDots} alt="ActionDots" />
                </Space>
            </Dropdown>
        </div>
    };

    const handleConsultationRowClick = (consultationDetail) => {
        handleAction("view", consultationDetail);
    };

    const handleConsultationClose = () => {
        setConsultationBooleans(prev => ({ ...prev, isconsultationDrawerOpen: false }));
    };

    const handleOpenRefundModal = () => {
        const consultationInfo = consultationIdData?.consultationInfo || {};
        if (consultationFilters?.activeTab === "CANCELLED" || consultationInfo?.consultationStatus === "CANCELLED") {
            return;
        }
        if (isConsultationRefundExpired(consultationInfo?.consultationDate)) {
            showErrorNotification("Error", "Refund window has expired (more than 2 days after consultation date)");
            return;
        }
        const isRefunded = Boolean(consultationInfo?.isRefunded || consultationInfo?.refundStatus === "REFUNDED" || consultationInfo?.refundStatus === "SUCCESS" || Number(consultationInfo?.refundAmount || 0) > 0);
        if (isRefunded) {
            showErrorNotification("Error", "Refund has already been processed for this consultation");
            return;
        }

        const customerTransactionId = consultationInfo?.consultationPaymentDetails?.customerTransactionId;
        if (!customerTransactionId) {
            showErrorNotification("Error", "Customer Transaction ID not found");
            return;
        }

        setRefundModal({ open: true, loading: false });
    };

    const handleConfirmRefund = async () => {
        const consultationInfo = consultationIdData?.consultationInfo || {};
        const customerTransactionId = consultationInfo?.consultationPaymentDetails?.customerTransactionId;

        if (!customerTransactionId) {
            showErrorNotification("Error", "Customer Transaction ID not found");
            return;
        }

        setRefundModal((prev) => ({ ...prev, loading: true }));
        try {
            const txnRes = await api.get(`${TRANSACTIONMANAGEMENT}/${customerTransactionId}`);
            const txnData = txnRes?.data ?? txnRes;
            const txn = txnData?.result?.transactionResponse;

            if (!txn) {
                showErrorNotification("Error", txnData?.error?.message || "Failed to retrieve transaction details");
                setRefundModal((prev) => ({ ...prev, loading: false }));
                return;
            }

            const payoutPayload = {
                userId: txn?.userId || consultationInfo?.customerId || consultationInfo?.customerResponse?.customerId || "",
                transactionType: "CREDIT",
                paymentCategory: "REFUND_TO_CUSTOMER",
                transactionDate: dayjs().format("YYYY-MM-DD"),
                amount: Number(txn?.amount ?? 0),
                razorpayFee: Number(txn?.razorpayFee ?? 0),
                finalAmount: Number(txn?.finalAmount ?? 0),
                referenceId: txn?.referenceId || null,
                refundId: txn?.refundId || consultationInfo?.refundId || null,
                razorpayPaymentId: txn?.razorpayPaymentId || null,
                consultationIds: Array.isArray(txn?.consultationIds) && txn?.consultationIds?.length > 0
                    ? txn?.consultationIds
                    : (consultationInfo?.consultationId ? [consultationInfo?.consultationId] : []),
                status: "SUCCESS",
                customerTransactionId: txn?.transactionId || customerTransactionId,
                gatewayFees: Number(txn?.gatewayFees ?? txn?.razorpayFee ?? 0),
                lawyerFee: Number(txn?.lawyerFee ?? 0),
                tdsAmount: Number(txn?.tdsAmount ?? 0)
            };

            const isRecorded = Boolean(
                consultationInfo?.record === true ||
                String(consultationInfo?.record).toUpperCase() === "RECORDED" ||
                String(consultationInfo?.record).toUpperCase() === "TRUE" ||
                consultationInfo?.consultationPaymentDetails?.recordDetail?.record === true ||
                consultationInfo?.consultationPaymentDetails?.recordDetail?.isRecord === true ||
                Boolean(consultationInfo?.consultationPaymentDetails?.recordDetail?.recordingUrl) ||
                consultationInfo?.recordDetail?.record === true ||
                consultationInfo?.recordDetail?.isRecord === true ||
                Boolean(consultationInfo?.recordDetail?.recordingUrl) ||
                txn?.record === true ||
                String(txn?.record).toUpperCase() === "RECORDED" ||
                String(txn?.record).toUpperCase() === "TRUE" ||
                txn?.recordDetail?.record === true ||
                txn?.recordDetail?.isRecord === true ||
                Boolean(txn?.recordDetail?.recordingUrl)
            );

            if (isRecorded) {
                payoutPayload.record = true;
            }

            const refundRes = await api.post(`${PAYMENTMANAGEMENT}/create_transaction_for_payout`, payoutPayload);
            const refundData = refundRes?.data ?? refundRes;

            const isSuccess =
                refundRes?.status === 200 ||
                refundRes?.status === 201 ||
                (typeof refundData === "string" && refundData.trim().length > 0) ||
                refundData?.statusCode === 200 ||
                refundData?.statusCode === 201 ||
                refundData?.status === "OK" ||
                refundData?.status === 200;
            const isError =
                refundData?.error ||
                (typeof refundData?.statusCode === "number" && refundData?.statusCode >= 400) ||
                refundData?.status === "ERROR";

            if (isSuccess && !isError) {
                showSuccessNotification(
                    "Success",
                    typeof refundData === "object"
                        ? (refundData?.result?.message || refundData?.message || "Refund processed successfully")
                        : "Refund processed successfully"
                );
                setRefundModal({ open: false, loading: false });
                handleConsultationClose();
                fetchConsultation();
            } else {
                showErrorNotification(
                    "Error",
                    parseErrorMessage(refundData?.error?.message || refundData?.response?.data?.error?.message || refundData?.message, "Failed to process refund")
                );
                setRefundModal((prev) => ({ ...prev, loading: false }));
            }
        } catch (error) {
            showErrorNotification(
                "Error",
                parseErrorMessage(error?.response?.data?.error?.message || error?.message, "Failed to process refund")
            );
            setRefundModal((prev) => ({ ...prev, loading: false }));
        }
    };

    const handleSendMessageClose = () => {
        setConsultationBooleans(prev => ({ ...prev, isSendMessage: false, isSendWarningMessage: false }));
        setMessageData(prev => ({ ...prev, activeTab: "raised", activeTabKey: "1", isMail: true, isWhatsapp: false, body: "", subject: "" }));
    };

    const handleMonthChange = (month) => {
        const monthValue = dayjs(month).format("YYYY-MM");
        if (month) {
            setConsultationFilter(prev => ({ ...prev, month: month, monthString: monthValue, fromDate: "", toDate: "", year: "" }));
        }
        else {
            setConsultationFilter(prev => ({ ...prev, month: null, monthString: "" }));
        }
    };

    const handleDateChange = (date) => {
        const fromDate = dayjs(date?.[0]).format("YYYY-MM-DD");
        const toDate = dayjs(date?.[1]).format("YYYY-MM-DD");
        if (date) {
            if (fromDate && toDate) {
                setConsultationFilter(prev => ({ ...prev, fromDate: fromDate, toDate: toDate, month: null, monthString: "", year: "" }));
            }
        }
        else {
            setConsultationFilter(prev => ({ ...prev, fromDate: "", toDate: "" }));
        }
    };

    const debounceSearch = (searchTerm) => {
        if (debounceTimeOut?.current) {
            clearTimeout(debounceTimeOut?.current);
        }
        if (searchTerm !== "") {
            debounceTimeOut.current = setTimeout(() => {
                setConsultationFilter(prev => ({ ...prev, searchTermValue: searchTerm }));
            }, searchInitiateDelayTime);
        }
        else {
            setConsultationFilter(prev => ({ ...prev, searchTermValue: "" }));
        }
    };

    const handleConsultationReport = () => {
        setConsultationFilter(prev => ({ ...prev, size: -1, isReportOpen: true }));
    };

    const handleSearch = (searchValue) => {
        const searchTerm = searchValue;
        setConsultationFilter(prev => ({ ...prev, searchFilter: searchTerm }));
        debounceSearch(searchTerm);
    };

    const handlePagination = (page, size) => {
        setConsultationFilter(prev => ({ ...prev, page: page - 1, size: size }));
    };

    const handlComplaintsDetailClose = () => {
        setConsultationBooleans(prev => ({ ...prev, isComplaintDrawerOpen: false, isDownloadButtonEnable: false }));
        setSelectedConsultationForComplaint({});
    };

    const handleSendMessage = (messageType, list) => {
        setConsultationBooleans(prev => ({ ...prev, isSendMessage: messageType === "sendMessage", isSendWarningMessage: messageType === "sendWarningMessage" }));
        setMessageData(prev => ({
            ...prev, complaintType: list?.data?.complaintType,
            warning: messageType === "sendWarningMessage",
            againstById: list?.data?.againstById,
            raisedById: list?.data?.raisedById,
            complaintId: list?.data?.complaintId,
            warnedBy: userId,
        }));
    };

    const handleMessageTabChange = (key) => {
        messageTabData?.forEach((tab) => {
            if (tab?.key === key) {
                const { content } = tab || {};
                setMessageData(prev => ({ ...prev, activeTab: content }));
            }
            setMessageData(prev => ({ ...prev, activeTabKey: key }));
            setMessageData(prev => ({ ...prev, body: "", subject: "", isWhatsapp: false, isMail: true }));
        });
    };

    const handleMessageChange = (fieldValue, fieldName) => {
        setMessageData(prev => ({ ...prev, [fieldName]: fieldValue }));
    };

    const handleMessageCheck = (check, type) => {
        if (type === "whatsapp") {
            setMessageData(prev => ({ ...prev, isWhatsapp: check }));
        }
        else if (type === "mail") {
            setMessageData(prev => ({ ...prev, isMail: check }));
        }
        else if (type === "warning") {
            setMessageData(prev => ({ ...prev, warning: check }));
        }
    };

    const handleYearChange = (year) => {
        setConsultationFilter(prev => ({ ...prev, year: year, fromDate: "", toDate: "", month: null, monthString: "" }));
    };

    const handleSubmitMessage = () => {
        const basePayload = {
            ...(messageData?.activeTab === "against" ? { againstById: messageData?.againstById } : {}),
            ...(messageData?.activeTab === "raised" ? { raisedById: messageData?.raisedById } : {}),
            complaintType: messageData?.complaintType,
            subject: messageData?.subject,
            body: messageData?.body,
            warning: messageData?.warning,
            complaintId: messageData?.complaintId,
            warnedBy: messageData?.warnedBy
        };
        if (messageData?.isWhatsapp && messageData?.isMail) {
            queryClient.prefetchQuery(["SEND_MESSAGE_WHATSAPP", ""], () => sendWhatsAppMessage({ ...basePayload, warnedIn: "WHATSAPP" }));
            queryClient.prefetchQuery(["SEND_MESSAGE_MAIL", ""], () => sendMailMessage({ ...basePayload, warnedIn: "EMAIL" }));
        }
        else if (messageData?.isWhatsapp) {
            queryClient.prefetchQuery(["SEND_MESSAGE_WHATSAPP", ""], () => sendWhatsAppMessage({ ...basePayload, warnedIn: "WHATSAPP" }));
        }
        else if (messageData?.isMail) {
            queryClient.prefetchQuery(["SEND_MESSAGE_MAIL", ""], () => sendMailMessage({ ...basePayload, warnedIn: "EMAIL" }));
        }
    };

    useEffect(() => {
        if (consultationFilters?.isReportOpen) {
            handlePrint();
        }
    }, [consultationFilters?.isReportOpen, handlePrint]);

    useEffect(() => {
        const isLoading = isFetchingAllConsultation || isFetchingConsultationById || isFetchingComplaintById || isFetchingSenfMailMessage || refundModal?.loading;
        dispatch(loaderReducer(isLoading));
    }, [dispatch, isFetchingAllConsultation, isFetchingConsultationById, isFetchingComplaintById, isFetchingSenfMailMessage, refundModal?.loading]);

    useEffect(() => {
        const isMail = messageData?.isMail ?? true;
        const isButtonEnable = Boolean(messageData?.subject && messageData?.body && (messageData?.isWhatsapp || isMail));
        if (messageData?.isButtonEnable !== isButtonEnable) {
            setMessageData(prev => ({ ...prev, isButtonEnable: isButtonEnable }));
        }
    }, [messageData?.subject, messageData?.body, messageData?.isWhatsapp, messageData?.isMail, messageData?.isButtonEnable]);

    const totalConsultationCount = consultationData?.consultationResponses?.totalElements || 0;
    const shouldShowConsultationPagination = totalConsultationCount > 10;

    return <>
        <div className="flexible">
            <h6 style={{ padding: "10px", margin: 0 }}>Consultations</h6>
            <div className="flexible">
                <DatePicker picker="month" format="MMM" value={consultationFilters?.month} style={{ height: 32, width: 150 }} onChange={(month) => handleMonthChange(month)} disabledDate={(current) => current && current > dayjs().endOf("day")} />
                <DatePicker picker="year" value={dayjs(consultationFilters?.year).isValid() ? dayjs(consultationFilters?.year) : null} format="YYYY" disabledDate={(current) => current && current > dayjs().endOf("day")} onChange={(year) => handleYearChange(year ? year : null)} />
                <UiRangePicker value={consultationFilters?.fromDate && consultationFilters?.toDate ? [dayjs(consultationFilters?.fromDate), dayjs(consultationFilters?.toDate)] : null} disabledDate={(current) => current && current > dayjs().endOf("day")} onChange={(date) => handleDateChange(date)} />
                <UiSearch placeholder={keywords?.searchPlaceHolder} value={consultationFilters?.searchFilter} onChange={(search) => handleSearch(search?.target?.value)} />
                <UiButton type="primary" onClick={handleConsultationReport}><img src={downloadReport} alt="" /> Download Report</UiButton>
            </div>
        </div>
        <div className="consultation-summary-scroll" style={{ padding: "15px 0px", width: "100%", overflowX: "auto" }}>
            <div className="d-flex gap-1 w-100 flex-nowrap">
                <div className="consultation-card">
                    <div className="d-flex justify-content-left gap-2">
                        <img src={totalConsultationIcon} alt="" />
                        <p className="consultation-card-title">Total Cons.</p>
                    </div>
                    <h3 className="fw-bold mb-0 fs-6">{consultationData?.totalConsultation}</h3>
                    <small className="todays-count">Today : <span>{consultationData?.todayConsultation}</span></small>
                </div>
                <div className="consultation-card">
                    <div className="d-flex justify-content-left gap-2">
                        <img src={completeConsultationIcon} alt="" />
                        <p className="text-success consultation-card-title">Total Complete Cons.</p>
                    </div>
                    <h3 className="fw-bold mb-0 text-success fs-6">{consultationData?.completeConsultation}</h3>
                    <small className="todays-count">Completed Today : <span>{consultationData?.toadyCompleteConsultation}</span></small>
                </div>
                <div className="consultation-card">
                    <div className="d-flex justify-content-left gap-2">
                        <img src={upcomingConsultationIcon} alt="" />
                        <p className="consultation-card-title" style={{ color: "#CA6500" }}>Total Upcoming Cons.</p>
                    </div>
                    <h3 className="fw-bold mb-0 fs-6" style={{ color: "#CA6500" }}>{consultationData?.upComingConsultation}</h3>
                    <small className="todays-count">Pending Today : <span>{consultationData?.todayUpComingConsultation}</span></small>
                </div>
                <div className="consultation-card">
                    <div className="d-flex justify-content-left gap-2">
                        <img src={cancelConsultationIcon} alt="" />
                        <p className="text-danger consultation-card-title">Total Cancelled Cons.</p>                                </div>
                    <h3 className="fw-bold mb-0 text-danger fs-6">{consultationData?.cancelledConsultation}</h3>
                    <small className="todays-count">Cancelled Today : <span>{consultationData?.todayCancelledConsultation}</span></small>
                </div>
                <div className="consultation-card">
                    <div className="d-flex justify-content-left gap-2">
                        <img src={closeIcon} alt="" />
                        <p className="consultation-card-title">Auto Cancelled Cons.</p>
                    </div>
                    <h3 className="fw-bold mb-0 fs-6">{consultationData?.autoCancelledConsultation}</h3>
                    <small className="todays-count">Today Cancelled : <span>{consultationData?.todayAutoCancelledConsultation}</span></small>
                </div>
                <div className="consultation-card">
                    <div className="d-flex justify-content-left gap-2">
                        <img src={consultationAmountIcon} alt="" />
                        <p className="consultation-card-title">Total Cons. Amount</p>
                    </div>
                    <h3 className="fw-bold mb-0 fs-6">{formatAmount(consultationData?.totalConsultationAmount)}</h3>
                    <small className="todays-count">Today Amount : <span>{consultationData?.todayConsultationAmount}</span></small>
                </div>
                <div className="consultation-card">
                    <div className="d-flex justify-content-left gap-2">
                        <img src={gstIcon} alt="" />
                        <p className="consultation-card-title">Gst Amount</p>
                    </div>
                    <h3 className="fw-bold mb-0 fs-6">{formatAmount(consultationData?.totalConsultationGstAmount)}</h3>
                    <small className="todays-count">Today Gst : <span>{consultationData?.todayConsultationGstAmount}</span></small>
                </div>
                <div className="consultation-card">
                    <div className="d-flex justify-content-left gap-2">
                        <img src={refundIcon} alt="" />
                        <p className="consultation-card-title">Refund Amount</p>
                    </div>
                    <h3 className="fw-bold mb-0 fs-6">{formatAmount(consultationData?.totalRefundAmount)}</h3>
                    <small className="todays-count">Today Refund Amount : <span>{formatAmount(consultationData?.todayRefundAmount)}</span></small>
                </div>
                <div className="consultation-card">
                    <div className="d-flex justify-content-left gap-2">
                        <img src={revenueIcon} alt="" />
                        <p className="consultation-card-title">Revenue</p>
                    </div>
                    <h3 className="fw-bold mb-0 fs-6">{formatAmount(consultationData?.totalRevenue)}</h3>
                    <small className="todays-count">Today Revenue : <span>{consultationData?.todayRevenue}</span></small>
                </div>
                <div className="consultation-card">
                    <div className="d-flex justify-content-left gap-2">
                        <img src={lawyerFees} alt="" />
                        <p className="consultation-card-title">Total Advocate Fee</p>
                    </div>
                    <h3 className="fw-bold mb-0 fs-6">{formatAmount(consultationData?.totalLawyerFee)}</h3>
                    <small className="todays-count">Today Advocate Fee : <span>{formatAmount(consultationData?.todayLawyerFee)}</span></small>
                </div>
            </div>
        </div>
        <div>
            <UiTab tabs={tabData} activeTabKey={consultationFilters?.activeTabKey} onChange={handleTabChanges} count={consultationData?.consultationResponses?.totalElements} />
            <UiTable
                scroll={{ x: "max-content", y: "calc(100vh - 370px)" }}
                columns={CONSULTATION_MONITORING_HEADER_COLUMNS({ actionRender, getConsultationDropdown, activeTab: consultationFilters?.activeTab })}
                dataSource={consultationData?.consultationResponses?.content}
                onRow={(consultationDetail) => ({
                    onClick: () => handleConsultationRowClick(consultationDetail)
                })}
                pagination={consultationFilters?.isReportOpen || !shouldShowConsultationPagination ? false : {
                    pageSize: consultationFilters?.size || 10,
                    current: consultationFilters?.page + 1,
                    total: totalConsultationCount,
                    pageSizeOptions: tablePageSizeOptions,
                    showSizeChanger: true,
                    onChange: (page, size) => handlePagination(page, size)
                }}
            />
        </div>
        {
            consultationBooleans?.isconsultationDrawerOpen && <ConsultationView
                consultation={consultationFilters}
                consultationBooleans={consultationBooleans}
                consultationIdData={consultationIdData}
                handleConsultationClose={handleConsultationClose}
                onRefund={consultationFilters?.activeTab !== "CANCELLED" && consultationIdData?.consultationInfo?.consultationStatus !== "CANCELLED" && (consultationFilters?.activeTab === "COMPLETED" || consultationFilters?.activeTab === "AUTO_CANCELLED" || ["COMPLETED", "AUTO_CANCELLED"].includes(consultationIdData?.consultationInfo?.consultationStatus)) ? handleOpenRefundModal : undefined}
                isRefundDisabled={Boolean(
                    consultationIdData?.consultationInfo?.isRefunded ||
                    consultationIdData?.consultationInfo?.refundStatus === "REFUNDED" ||
                    consultationIdData?.consultationInfo?.refundStatus === "SUCCESS" ||
                    Number(consultationIdData?.consultationInfo?.refundAmount || 0) > 0 ||
                    isConsultationRefundExpired(consultationIdData?.consultationInfo?.consultationDate)
                )}
            />}
        <Modal
            open={refundModal?.open}
            onCancel={() => setRefundModal({ open: false, loading: false })}
            footer={null}
            centered
            width={420}
            closable={false}
            zIndex={2000}
            className="refund-confirm-modal"
        >
            <div className="modal-content" style={{ padding: "16px", textAlign: "center" }}>
                <div style={{ display: "flex", justifyContent: "center", marginBottom: "16px" }}>
                    <ExclamationCircleOutlined style={{ fontSize: "48px", color: "#faad14" }} />
                </div>
                <h3 style={{ fontSize: "18px", fontWeight: "600", marginBottom: "12px", color: "#1f1f1f" }}>
                    Confirm Refund
                </h3>
                <p style={{ fontSize: "14px", color: "#595959", marginBottom: "16px" }}>
                    Are you sure you want to process a refund for consultation <strong>{consultationIdData?.consultationInfo?.consultationNo || ""}</strong>?
                </p>
                <div style={{ backgroundColor: "#f5f5f5", borderRadius: "8px", padding: "12px", marginBottom: "20px", textAlign: "left" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "6px" }}>
                        <span style={{ color: "#8c8c8c", fontSize: "13px" }}>Customer:</span>
                        <span style={{ fontWeight: "500", fontSize: "13px" }}>
                            {`${consultationIdData?.consultationInfo?.customerResponse?.firstName || ""} ${consultationIdData?.consultationInfo?.customerResponse?.lastName || ""}`.trim() || "-"}
                        </span>
                    </div>
                    <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "6px" }}>
                        <span style={{ color: "#8c8c8c", fontSize: "13px" }}>Transaction ID:</span>
                        <span style={{ fontWeight: "500", fontSize: "13px" }}>
                            {consultationIdData?.consultationInfo?.consultationPaymentDetails?.customerTransactionId || "-"}
                        </span>
                    </div>
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <span style={{ color: "#8c8c8c", fontSize: "13px" }}>Refund Amount:</span>
                        <span style={{ fontWeight: "600", fontSize: "14px", color: "#005D60" }}>
                            ₹ {formatAmount(consultationIdData?.consultationInfo?.consultationPaymentDetails?.totalConsultationAmount || 0)}
                        </span>
                    </div>
                </div>
                <div style={{ display: "flex", justifyContent: "center", gap: "12px" }}>
                    <UiButton
                        onClick={() => setRefundModal({ open: false, loading: false })}
                        disabled={refundModal?.loading}
                    >
                        Cancel
                    </UiButton>
                    <UiButton
                        type="primary"
                        disabled={refundModal?.loading}
                        onClick={handleConfirmRefund}
                    >
                        {refundModal?.loading ? "Processing..." : "Confirm Refund"}
                    </UiButton>
                </div>
            </div>
        </Modal>
        {
            consultationBooleans?.isComplaintDrawerOpen && <ComplaintView
                consultationBooleans={consultationBooleans}
                handlComplaintsDetailClose={handlComplaintsDetailClose}
                handleSendMessage={handleSendMessage}
                handleSendMessageClose={handleSendMessageClose}
                complaintIdData={complaintIdData}
                handleMessageChange={handleMessageChange}
                handleMessageTabChange={handleMessageTabChange}
                messageData={messageData}
                handleMessageCheck={handleMessageCheck}
                handleSubmitMessage={handleSubmitMessage}
                isFetchingSendMessage={isFetchingSendMessage}
            />}
        <div style={{ display: "none" }}>
            <PrintConsultationReports ref={reportRef} data={consultationData?.consultationResponses?.content} fromDate={consultationFilters?.fromDate} toDate={consultationFilters?.toDate} activeTab={consultationFilters?.activeTab} consultationMonitoring={consultationData} month={consultationFilters?.month} year={consultationFilters?.year} minFilter={consultationFilters?.consultationTime} searchFilter={consultationFilters?.searchTermValue} />
        </div>
    </>
};
export default ConsultationMonitoring;